/**
 * @generated SignedSource<<aa4cd06774d122ccc07b0a26de7286a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoEditFeedbackPopover_todo$data = {
  readonly allTodoFeedbacks: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopoverFeedbackHistory_todoFeedback">;
  }>;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopoverSendFeedbackForm_todo">;
  readonly " $fragmentType": "TodoEditFeedbackPopover_todo";
};
export type TodoEditFeedbackPopover_todo$key = {
  readonly " $data"?: TodoEditFeedbackPopover_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopover_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditFeedbackPopover_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditFeedbackPopoverSendFeedbackForm_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoFeedback",
      "kind": "LinkedField",
      "name": "allTodoFeedbacks",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoEditFeedbackPopoverFeedbackHistory_todoFeedback"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "3d1d6530894fc7385bed7d3138c61d41";

export default node;
